module.exports = __webpack_public_path__ + "static/img/10.b1dc641.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/sp/10.png
// module id = HL+6
// module chunks = 0